import { render, staticRenderFns } from "./packageFilter.vue?vue&type=template&id=f5c31a60"
import script from "./packageFilter.vue?vue&type=script&lang=js"
export * from "./packageFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports